/* ============================================================================
   SILCO HAUS — Artists Listing v2  (no framework)
   Facets derived from data (empty groups/options never render, but light up
   automatically once an artist carries that value). Multi-select within a group
   = OR, across groups = AND. Facet counts ignore their own group. URL-encoded
   state (shareable, back/forward). Client-side while the roster is small; the
   ?param contract lets it move server-side later without a redesign.
   ============================================================================ */
(function () {
  'use strict';

  var FACET_DEFS = [
    { key: 'category',     title: 'Category',     field: 'cat',     list: true,  collapsible: false },
    { key: 'discipline',   title: 'Discipline',   field: 'disc',    list: false, collapsible: true },
    { key: 'country',      title: 'Country',      field: 'country', list: false, collapsible: true },
    { key: 'availability', title: 'Availability', field: 'avail',   list: false, collapsible: false },
    { key: 'price',        title: 'Price from',   field: 'price',   list: false, collapsible: false, price: true }
  ];

  function init(root) {
    if (!root || root.__alInit) return;
    root.__alInit = true;

    var cfg = readJSON(root.querySelector('[data-al-config]')) || {};
    var artists = readJSON(root.querySelector('[data-al-artists]')) || [];
    var bands = cfg.bands || [['Under $250', 0, 250], ['$250 – $750', 250, 750], ['$750+', 750, 1e12]];
    var perPage = cfg.per_page || 24;
    var facetMin = cfg.facet_min_values || 2;
    var collapseAfter = cfg.collapse_after || 5;

    var el = {
      grid: root.querySelector('[data-al-grid]'),
      count: root.querySelectorAll('[data-al-count]'),
      shown: root.querySelector('[data-al-shown]'),
      moreWrap: root.querySelector('[data-al-morewrap]'),
      loadMore: root.querySelector('[data-al-loadmore]'),
      empty: root.querySelector('[data-al-empty]'),
      chips: root.querySelector('[data-al-chips]'),
      sidebarFacets: root.querySelector('[data-al-facets="sidebar"]'),
      sheetFacets: root.querySelector('[data-al-facets="sheet"]'),
      sortBtns: root.querySelectorAll('[data-al-sort]'),
      searchInputs: root.querySelectorAll('[data-al-search]'),
      filterBtn: root.querySelector('[data-al-open-sheet]'),
      filterBtnCount: root.querySelector('[data-al-filter-count]'),
      sheet: root.querySelector('[data-al-sheet]'),
      sheetClose: root.querySelectorAll('[data-al-close-sheet]'),
      sheetApply: root.querySelector('[data-al-apply-sheet]'),
      clearAll: root.querySelectorAll('[data-al-clearall]')
    };
    var cards = {};
    Array.prototype.forEach.call(root.querySelectorAll('[data-al-id]'), function (c) { cards[c.getAttribute('data-al-id')] = c; });

    // ---- state ----
    var state = { sort: cfg.default_sort || 'featured', search: '', page: 1, expand: {} };
    FACET_DEFS.forEach(function (f) { state[f.key] = []; });
    readURL();

    // ---- helpers ----
    function valueOf(a, def) { return def.price ? a[def.field] : a[def.field]; }
    function inBand(price, label) {
      if (price == null || price === '') return false;
      var b = bands.filter(function (x) { return x[0] === label; })[0];
      return b && price >= b[1] && price < b[2];
    }
    function artistMatchesGroup(a, def) {
      var sel = state[def.key];
      if (!sel.length) return true;
      if (def.price) return sel.some(function (l) { return inBand(a.price, l); });
      if (def.list) { var arr = a[def.field] || []; return sel.some(function (v) { return arr.indexOf(v) !== -1; }); }
      return sel.indexOf(a[def.field]) !== -1;
    }
    function matchesSearch(a) {
      if (!state.search) return true;
      var q = state.search.toLowerCase();
      return (a.name || '').toLowerCase().indexOf(q) !== -1 ||
             (a.disc || '').toLowerCase().indexOf(q) !== -1 ||
             (a.country || '').toLowerCase().indexOf(q) !== -1;
    }
    function matches(a, skipKey) {
      if (!matchesSearch(a)) return false;
      for (var i = 0; i < FACET_DEFS.length; i++) {
        var def = FACET_DEFS[i];
        if (def.key === skipKey) continue;
        if (!artistMatchesGroup(a, def)) return false;
      }
      return true;
    }
    function distinctValues(def) {
      var seen = {}, out = [];
      artists.forEach(function (a) {
        var vals = def.price ? bands.map(function (b) { return b[0]; })
                 : def.list ? (a[def.field] || [])
                 : (a[def.field] ? [a[def.field]] : []);
        vals.forEach(function (v) {
          if (def.price) { // only include bands that at least one artist falls into
            if (!artists.some(function (x) { return inBand(x.price, v); })) return;
          }
          if (!seen[v]) { seen[v] = 1; out.push(v); }
        });
      });
      if (!def.price) out.sort(function (x, y) { return x.localeCompare(y); });
      else out.sort(function (x, y) { return bands.findIndex(function (b){return b[0]===x;}) - bands.findIndex(function (b){return b[0]===y;}); });
      return out;
    }
    function countFor(def, value) {
      var pool = artists.filter(function (a) { return matches(a, def.key); });
      if (def.price) return pool.filter(function (a) { return inBand(a.price, value); }).length;
      if (def.list) return pool.filter(function (a) { return (a[def.field] || []).indexOf(value) !== -1; }).length;
      return pool.filter(function (a) { return a[def.field] === value; }).length;
    }

    // ---- rendering: facets ----
    function buildFacets(container, isSheet) {
      if (!container) return;
      container.innerHTML = '';
      FACET_DEFS.forEach(function (def) {
        var values = distinctValues(def);
        if (values.length < facetMin) return; // group hidden until it has enough distinct values
        var group = document.createElement('fieldset');
        group.className = 'al2-group';
        group.style.border = 'none'; group.style.margin = '0'; group.style.padding = group.style.padding || '';
        var head = document.createElement('div'); head.className = 'al2-group-head';
        var legend = document.createElement('legend'); legend.className = 'al2-group-title'; legend.textContent = def.title;
        head.appendChild(legend);
        if (cfg.show_facet_counts !== false) {
          var badge = document.createElement('div'); badge.className = 'al2-group-badge';
          var sc = state[def.key].length; badge.textContent = sc ? sc + ' selected' : '';
          head.appendChild(badge);
        }
        group.appendChild(head);

        var expanded = !!state.expand[def.key];
        var shownVals = (def.collapsible && !expanded) ? values.slice(0, collapseAfter) : values;
        shownVals.forEach(function (v) {
          var checked = state[def.key].indexOf(v) !== -1;
          var btn = document.createElement('button');
          btn.type = 'button'; btn.className = 'al2-opt'; btn.setAttribute('aria-pressed', checked ? 'true' : 'false');
          var box = document.createElement('span'); box.className = 'al2-box';
          var dot = document.createElement('span'); dot.className = 'al2-box-dot'; box.appendChild(dot);
          var label = document.createElement('span'); label.className = 'al2-opt-label'; label.textContent = v;
          btn.appendChild(box); btn.appendChild(label);
          if (cfg.show_facet_counts !== false) {
            var cnt = document.createElement('span'); cnt.className = 'al2-opt-count'; cnt.textContent = countFor(def, v);
            btn.appendChild(cnt);
          }
          btn.addEventListener('click', function () { toggle(def.key, v); });
          group.appendChild(btn);
        });
        if (def.collapsible && values.length > collapseAfter) {
          var more = document.createElement('button');
          more.type = 'button'; more.className = 'al2-more';
          more.textContent = expanded ? 'Show less' : ('Show ' + (values.length - collapseAfter) + ' more');
          more.addEventListener('click', function () { state.expand[def.key] = !state.expand[def.key]; renderFacets(); });
          group.appendChild(more);
        }
        container.appendChild(group);
      });
    }
    function renderFacets() { buildFacets(el.sidebarFacets, false); buildFacets(el.sheetFacets, true); }

    // ---- rendering: chips ----
    function renderChips() {
      if (!el.chips) return;
      el.chips.innerHTML = '';
      var n = 0;
      FACET_DEFS.forEach(function (def) {
        state[def.key].forEach(function (v) {
          n++;
          var chip = document.createElement('button');
          chip.type = 'button'; chip.className = 'al2-chip';
          chip.innerHTML = '<span></span><span class="al2-chip-x">×</span>';
          chip.firstChild.textContent = v;
          chip.addEventListener('click', function () { toggle(def.key, v); });
          if (cfg.show_applied_chips !== false) el.chips.appendChild(chip);
        });
      });
      if (el.filterBtnCount) { el.filterBtnCount.textContent = n ? '(' + n + ')' : ''; el.filterBtnCount.hidden = !n; }
    }

    // ---- rendering: grid ----
    function sortList(list) {
      var s = state.sort;
      return list.slice().sort(function (a, b) {
        if (s === 'a_z') return (a.name || '').localeCompare(b.name || '');
        if (s === 'newest') return (b.onboarded || '').localeCompare(a.onboarded || '') || (a.name || '').localeCompare(b.name || '');
        if (s === 'most_works') return (b.works || 0) - (a.works || 0) || (a.name || '').localeCompare(b.name || '');
        // featured: explicit featured_order asc (0/blank last), then name
        var fa = a.featured ? a.featured : 1e9, fb = b.featured ? b.featured : 1e9;
        return fa - fb || (a.name || '').localeCompare(b.name || '');
      });
    }
    function renderGrid() {
      var filtered = sortList(artists.filter(function (a) { return matches(a); }));
      var total = filtered.length;
      var limit = state.page * perPage;
      // order + visibility
      filtered.forEach(function (a, i) {
        var c = cards[a.id]; if (!c) return;
        c.hidden = i >= limit;
        c.style.order = i;
        c.style.display = '';
      });
      artists.forEach(function (a) {
        if (filtered.indexOf(a) === -1) { var c = cards[a.id]; if (c) { c.hidden = true; c.style.display = 'none'; } }
      });
      var label = total + (total === 1 ? ' artist' : ' artists');
      Array.prototype.forEach.call(el.count, function (n) { n.textContent = label; });
      if (el.empty) el.empty.hidden = total !== 0;
      if (el.grid) el.grid.hidden = total === 0;
      var visible = Math.min(limit, total);
      if (el.shown) el.shown.textContent = 'Showing ' + visible + ' of ' + total;
      if (el.moreWrap) el.moreWrap.hidden = !(cfg.load_more_style !== 'none' && visible < total);
    }
    function renderSort() {
      Array.prototype.forEach.call(el.sortBtns, function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-al-sort') === state.sort ? 'true' : 'false');
      });
    }
    function render() { renderFacets(); renderChips(); renderSort(); renderGrid(); writeURL(); }

    // ---- actions ----
    function toggle(key, v) {
      var cur = state[key];
      state[key] = cur.indexOf(v) !== -1 ? cur.filter(function (x) { return x !== v; }) : cur.concat([v]);
      state.page = 1; render();
    }
    function clearAll() { FACET_DEFS.forEach(function (f) { state[f.key] = []; }); state.search = ''; Array.prototype.forEach.call(el.searchInputs, function (i) { i.value = ''; }); state.page = 1; render(); }

    // ---- URL ----
    function readURL() {
      var p = new URLSearchParams(location.search);
      FACET_DEFS.forEach(function (f) { var raw = p.get(f.key); if (raw) state[f.key] = raw.split(',').map(decodeURIComponent).filter(Boolean); });
      if (p.get('sort')) state.sort = p.get('sort');
      if (p.get('q')) state.search = p.get('q');
    }
    function writeURL() {
      var p = new URLSearchParams();
      FACET_DEFS.forEach(function (f) { if (state[f.key].length) p.set(f.key, state[f.key].join(',')); });
      if (state.sort && state.sort !== (cfg.default_sort || 'featured')) p.set('sort', state.sort);
      if (state.search) p.set('q', state.search);
      var qs = p.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
    }

    // ---- sheet (mobile) ----
    var lastFocus = null;
    function openSheet() { if (!el.sheet) return; lastFocus = document.activeElement; el.sheet.classList.add('is-open'); el.sheet.setAttribute('aria-hidden', 'false'); document.documentElement.style.overflow = 'hidden'; var f = el.sheet.querySelector('button'); if (f) f.focus(); }
    function closeSheet() { if (!el.sheet) return; el.sheet.classList.remove('is-open'); el.sheet.setAttribute('aria-hidden', 'true'); document.documentElement.style.overflow = ''; if (lastFocus) lastFocus.focus(); }

    // ---- wire ----
    Array.prototype.forEach.call(el.sortBtns, function (b) { b.addEventListener('click', function () { state.sort = b.getAttribute('data-al-sort'); state.page = 1; render(); }); });
    Array.prototype.forEach.call(el.searchInputs, function (i) {
      i.value = state.search;
      i.addEventListener('input', function () { state.search = i.value.trim(); state.page = 1; Array.prototype.forEach.call(el.searchInputs, function (o) { if (o !== i) o.value = i.value; }); render(); });
    });
    Array.prototype.forEach.call(el.clearAll, function (b) { b.addEventListener('click', clearAll); });
    if (el.loadMore) el.loadMore.addEventListener('click', function () { state.page++; renderGrid(); });
    if (el.filterBtn) el.filterBtn.addEventListener('click', openSheet);
    Array.prototype.forEach.call(el.sheetClose, function (b) { b.addEventListener('click', closeSheet); });
    if (el.sheetApply) el.sheetApply.addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.sheet && el.sheet.classList.contains('is-open')) closeSheet(); });
    // infinite scroll option
    if (cfg.load_more_style === 'infinite' && el.moreWrap) {
      var io = new IntersectionObserver(function (ents) { ents.forEach(function (en) { if (en.isIntersecting && !el.moreWrap.hidden) { state.page++; renderGrid(); } }); });
      io.observe(el.moreWrap);
    }

    render();
  }

  function readJSON(node) { if (!node) return null; try { return JSON.parse(node.textContent); } catch (e) { return null; } }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-al-root]'), init); }

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-al-root]'); if (r) { r.__alInit = false; init(r); } });
})();
